import React from 'react';
import { ProtectedLayout } from '../components/layout/ProtectedLayout';
import { KarmaPanel } from '../components/karma/KarmaPanel';

const KarmaPage: React.FC = () => (
  <ProtectedLayout>
    {({ user }) => {
      const isAdmin = user.is_staff || user.username.toLowerCase() === 'admin';
      return (
        <div className="space-y-8">
          <header className="rounded-xl border border-border bg-card p-6 shadow-sm">
            <h1 className="text-3xl font-semibold text-foreground">Karma Overview</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Track reward and punishment progress for Kitten.
            </p>
          </header>
          <KarmaPanel isAdmin={isAdmin} />
        </div>
      );
    }}
  </ProtectedLayout>
);

export default KarmaPage;
